import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { mail } from "../common";
import Loading from "../components/Loading";
import swal from "sweetalert";
import { useAccess } from "../context/AccessContext";
interface User {
  email: string;
  accessToken: string;
}
export const redirectToLogin = (currentPath?: string) => {
  // First clear the storage
  localStorage.clear();
  // Then store the intended URL (default to full current URL if not provided)
  const path = currentPath || (window.location.pathname + window.location.search + window.location.hash);
  localStorage.setItem("intendedUrl", path);
  // Finally redirect to login
  window.location.href = "/login";
};

export const Protected = ({ children }: any) => {
  const location = useLocation();
  const loggedIn = JSON.parse(localStorage.getItem("loggedIn")!);

  if (loggedIn) {
    // console.log("User is logged in, proceeding to:", location.pathname);
    return children;
  } else {
    // console.log("User not logged in, storing URL:", location.pathname);
    // Store the intended URL before redirecting to login
    localStorage.setItem("intendedUrl", location.pathname + location.search + location.hash);
    return <Navigate to="/login" />;
  }
};

export const isLoggedIn = () => {
  const loggedIn = localStorage.getItem("loggedIn")!;
  return loggedIn === "true";
};

export const getAccessToken = () => {
  const token = localStorage.getItem("token");
  return token;
};

export const getLoggedIn = (): boolean => {
  const loggedIn = localStorage.getItem("loggedIn");
  return loggedIn === "true";
};

export const setSessionToken = (token: string) => {
  localStorage.setItem("token", token);
};

export const setLoggedIn = (loggedIn: boolean) => {
  localStorage.setItem("loggedIn", JSON.stringify(loggedIn));
};

export const setUser = ({
  email,
  accessToken,
}: {
  email: string;
  accessToken: string;
}) => {
  localStorage.setItem("email", email);
  localStorage.setItem("accessToken", accessToken);
  return {
    email: email,
    accessToken: accessToken,
  };
};

export const getUser = (): User => {
  const email = localStorage.getItem("email")!;
  const accessToken = localStorage.getItem("accessToken")!;
  return {
    email: email,
    accessToken: accessToken,
  };
};

export function ProtectedPage({
  children,
  pageId,
  accessKey,
  showPopUp = true,
}: {
  children: any;
  pageId: string;
  accessKey?: string;
  showPopUp?: boolean;
}) {
  const { accessMap, loading } = useAccess();
  const key = (accessKey ?? pageId.replace("/", "")).toLowerCase();
  const hasAccess = accessMap[key] === true;

  React.useEffect(() => {
    if (!loading && !hasAccess && showPopUp) {
      swal(
        "Access Denied",
        `Sorry, you do not have a subscription for this page. Please write to ${mail} to subscribe.`,
        "warning"
      );
    }
  }, [loading, hasAccess, showPopUp]);

  if (loading) return <Loading />;
  if (!hasAccess) return showPopUp ? <Navigate to="/dashboard" /> : null;
  return children;
}
